import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectIsAuthorized, selectTrackingInfo } from 'shared/selectors/user';
import { ContentWrapper } from '../../../components/ContentWrapper';
import { AuthorizationContainer } from '../../AuthorizationContainer';
import { FooterContainer } from '../../FooterContainer';
import { SubsidizedMortgageContainer } from '../../microfrontends/SubsidizedMortgageCalculator';
import { MortgageStepsContainer } from '../../MortgageStepsContainer';
import style from './style.css';
import { ArticleHeading2, Button } from '@cian/ui-kit';
import { selectBankInfo } from '../../../selectors/proposal';
import { BackButton } from '../../../components/BackButton/BackButton';
import { trackButtonClick } from '../../../utils/tracking/tracking';

export const MainPage = () => {
  const isAuthorized = useSelector(selectIsAuthorized);
  const bankInfo = useSelector(selectBankInfo);
  const user = useSelector(selectTrackingInfo);
  const calculatorDetailsRef = useRef<Record<string, unknown>>({});

  const handleUpdateCalculatorDetails = (e: CustomEvent) => {
    calculatorDetailsRef.current = e.detail.calculatorValues;
  };

  const onBottomButtonClick = () => {
    trackButtonClick(user, 'BankPageBottom', { calculatorData: calculatorDetailsRef.current });
  };

  const onTopButtonClick = () => {
    trackButtonClick(user, 'BankPageTop', { calculatorData: calculatorDetailsRef.current });
  };

  return (
    <div className={style['wrapper']}>
      <ContentWrapper>
        <BackButton />
        <AuthorizationContainer onTopButtonClick={onTopButtonClick} />
        <MortgageStepsContainer />
        {isAuthorized && (
          <div id="calc-widget">
            <div className={style['calc-header']}>
              {/* eslint-disable-next-line no-irregular-whitespace */}
              <ArticleHeading2>Рассчитайте ипотеку и отправьте заявку в банк через Госуслуги</ArticleHeading2>
            </div>
            <SubsidizedMortgageContainer onUpdateCalculatorDetails={handleUpdateCalculatorDetails} />
            <div className={style['btn-wrapper']}>
              <a href={bankInfo.redirectLink}>
                {/* eslint-disable-next-line no-irregular-whitespace */}
                <Button onClick={onBottomButtonClick}>Отправить заявку в банк через Госуслуги</Button>
              </a>
            </div>
          </div>
        )}
        <FooterContainer />
      </ContentWrapper>
    </div>
  );
};
